import { supabase } from '@/lib/supabase'

export async function estimateRecipients(plans: string[], roles: string[]): Promise<number> {
  const { data, error } = await supabase.rpc('estimate_broadcast_recipients', { p_plans: plans, p_roles: roles })
  if (error) throw error
  return Number(data || 0)
}

export async function createBroadcast(
  title: string,
  body: string,
  url: string | null,
  plans: string[],
  roles: string[],
  scheduledAt?: string | null,
): Promise<string> {
  const { data, error } = await supabase.rpc('admin_create_webpush_broadcast', {
    p_title: title,
    p_body: body,
    p_url: url,
    p_plans: plans,
    p_roles: roles,
    p_schedule: scheduledAt || null,
  })
  if (error) throw error
  return String(data)
}

export async function enqueueBroadcast(id: string): Promise<number> {
  const { data, error } = await supabase.rpc('enqueue_webpush_broadcast', { p_broadcast_id: id })
  if (error) throw error
  return Number(data || 0)
}

export async function enqueueBroadcastTestEmail(title: string, body: string, url: string | null, email: string): Promise<number> {
  const { data, error } = await supabase.rpc('admin_enqueue_broadcast_for_email', { p_title: title, p_body: body, p_url: url, p_email: email })
  if (error) throw error
  return Number(data || 0)
}

export async function estimateEligible(plans: string[], roles: string[]): Promise<number> {
  const { data, error } = await supabase.rpc('estimate_broadcast_eligible', { p_plans: plans, p_roles: roles })
  if (error) throw error
  return Number(data || 0)
}
